import { MaskedInput } from '@/behaviour/masked_input/index'
import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'
import { PopUps } from '@/utilities/popups'

export class UserCallbacks {
  // Page: /user_callbacks/new
  // есть в модале, поэтому перемещаем в behavior
  private base: JQuery | null = null

  private selectors: ISelectors = {
    form: '[data-selector="callbackPopupsForm"]',
    formWrapper: '[data-selector="callbackPopupsWrapper"]',
    popup: '[data-module-callback]',
  }

  public constructor() {
    this.base = $('body')
    this.getCallbackPopups()
    this.init(false)
  }

  private init(inModal: boolean = false): void {
    this.initValidationRules(inModal)
    this.initListeners()
  }

  private getCallbackPopups(): void {
    this.base
      .on('click', this.selectors.popup, (e) => {
        e.preventDefault()

        PopUps.showPopupByUrl(routes.new_user_callback_path(), {
          modalClose: false,
          openCallback: () => {
            this.init(true)
          },
        })
      })
  }

  private initListeners(): void {
    this.base
      .on('ajax:success', this.selectors.form, (e, response, textStatus, xhr) => {
        this.successHandler(e, response, textStatus, xhr)
      })
      .on('ajax:error', this.selectors.form, (e, data, status, xhr) => this.failureHandler(e, data, status, xhr))
  }

  // Наложить на форму правила валидации
  private initValidationRules(inModal: boolean = false): void {
    if (inModal) {
      $(this.selectors.formWrapper).find(this.selectors.form).validate()
      MaskedInput.reinit()
    } else {
      this.base.find(this.selectors.form).validate()
    }
  }

  private successHandler(e: JQuery.TriggeredEvent, response, textStatus: string, xhr: JQuery.jqXHR): void {
    const message = `<div class='registerPopups__txt'>Вам перезвонят в ближайшее время</div>`
    $(e.currentTarget).html(message)
  }

  private failureHandler(e: JQuery.TriggeredEvent, data, status, xhr): void {
    const content = status.responseText || 'На сервере произошла ошибка. Попробуйте еще раз'
    $(e.currentTarget).html(content)
  }
}
